import React from 'react';

const DashSVG = () => (
  <svg
    width="8"
    height="1em"
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.00109863"
      y="0.382812"
      width="8"
      height="3.27515"
      fill="#C4C4C4"
    />
  </svg>
);

export default DashSVG;
